import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { loadEvents, clearEvents } from '../store/entities/events'
import { setCurrentCustomer, setInfo, getLogo } from '../store/entities/customers'
import { withRouter, matchPath } from 'react-router-dom';
import { globalViewText, computeShowDropdown, superFeedViewText, getSuperFeedAsCustomer, isCredentialMonitoringEnabled } from '../utilities/config'

import logoWithText from '../assets/pixm-blue-on-white-logo-02@3x.png'
import OrgSvg from '../assets/org.svg'
import supportSvg from '../assets/support.svg'
import SelectBox from '../components/common/selectbox/selectBox'
import ProfilePopover from '../components/common/popover/profilePopover'
import './navbar.scss'
import { GLOBAL_VIEW_DISABLED_PATHS , GLOBAL_VIEW_DISABLED_MESSAGE} from '../utilities/globalViewDisabled';
import { 
  THREAT_INTEL_CUST_LICENSE_CODE, 
  THREAT_INTEL_DISABLED_MESSAGE, 
  THREAT_INTEL_CUST_VALID_PATHS, 
  PHISH_PROT_SUITE_CUST_LICENSE_CODE } from '../utilities/threatIntelCustomerUtils';

class Navbar extends Component {
  state = {
    showDropdown: computeShowDropdown(this.props.location),
    isPA : false,
  }

  componentDidMount(){
    this.loadLogo()
  }

  componentDidUpdate(prevProps) { 
    if(this.props !== prevProps){
      if(this.props.history.location.pathname !== "/login") {
        let match2;
        let match3;
        let match1 = matchPath(this.props.history.location.pathname, {
          path: '/customers/:param1/incidents',
          exact: true,
          strict: false
        })

        if(!match1){
          match2 = matchPath(this.props.history.location.pathname, {
            path: '/customers/:param1/incidents/:param2',
            exact: true,
            strict: false
          }) ||
          matchPath(this.props.history.location.pathname, {
            path: '/tenants/:param1/:param2/incidents/:param3',
            exact: true,
            strict: false
          }) || 
          matchPath(this.props.history.location.pathname, {
            path: '/customers/:param1/threat-intel/:param2',
            exact: true,
            strict: false
          }) ||
          matchPath(this.props.history.location.pathname, {
            path: '/tenants/:param1/:param2/threat-intel/:param3',
            exact: true,
            strict: false
          }) ||
          matchPath(this.props.history.location.pathname, {
            path: 'super-feed',
            exact: true,
            strict: false
          })
        }

        if (!match1 || !match2) {
          match3 = matchPath(this.props.history.location.pathname, {
            path: '/tenants/:param1/incidents/',
            exact: true,
            strict: false
          })
        }

        let match4;
        if (!match1 && !match2 && !match3) {
          match4 = matchPath(this.props.history.location.pathname, {
            path: '/customers/:param1/governance',
            exact: false,
            strict: false
          })
        }

        let match5;
        if (!match1 && !match2 && !match3 && !match4) {
          match5 = matchPath(this.props.history.location.pathname, {
            path: '/customers/:param1/policy-violations',
            exact: false,
            strict: false
          })
        }

        let match6;
        if (!match1 && !match2 && !match3 && !match4 && !match5) {
          // Both variants: the Incident Feed is reachable per-customer and in Global View.
          match6 = matchPath(this.props.history.location.pathname, {
            path: '/customers/:param1/incident-feed',
            exact: false,
            strict: false
          }) ||
          matchPath(this.props.history.location.pathname, {
            path: '/tenants/:param1/incident-feed',
            exact: false,
            strict: false
          })
        }

        let match =  match1 || match2 || match3 || match4 || match5 || match6;
        if(match) {
          let filtredElement = this.props.orgList.filter((ele) => ele.id === match.params.param1)
          
          if(filtredElement && filtredElement instanceof Array && filtredElement.length > 0 && filtredElement[0].id !== this.props.selectedCustomer.id && this.props.selectedCustomer.organizationName !== superFeedViewText) {
            this.props.setCurrentCustomer(filtredElement[0]);
          }
        }
      }

      if (this.props.location !== prevProps.location) {
        const shouldShowDropdown = computeShowDropdown(this.props.location)
        if (this.state.showDropdown !== shouldShowDropdown) {
            this.setState({ showDropdown: shouldShowDropdown });
        }
      }
      // to handle refresh when on super feed view, customer is set back to super feed customer
      else if (
        this.props.location === prevProps.location &&
        prevProps.location.pathname.includes('super-feed') &&
        this.props.selectedCustomer.id !== getSuperFeedAsCustomer().id
      ) {
        this.props.setCurrentCustomer(getSuperFeedAsCustomer());
      }

    }
  }

  loadLogo = () => {
    let body = {
      domainName : this.props.domain,
      fileName : "logo-medium-size.png"
    }
    if(this.props.tokenRoles =="PixmAdmin")
      {
          this.setState({
            ...this.state,
            isPA : true,
          })
      }
    else{
      this.props.getLogo(body);
    }
  }

  renderSelectedCustomerData = (selectedCustomer) => {
    let { pathname } = this.props.history.location
    let isGlobalView = selectedCustomer.organizationName === globalViewText;
    switch (true) {
      // ⚠️ MUST stay first. This switch(true) is order-sensitive and two later cases
      // swallow Incident Feed tabs if they get there first: `pathname.includes('user')`
      // matches /incident-feed/user-activity, and the `policy-violations` case matches
      // /incident-feed/policy-violations — either one lands the admin on a different
      // screen with no error when they switch customer. ('incidents' is safe:
      // 'incident-feed' does not contain it.) PIXMC-6521.
      case pathname.includes('incident-feed'): {
        // Carry the active tab across the customer switch. A query param could not do
        // this — this function returns a bare path, so ?type= would be dropped here.
        const tab = pathname.split('/incident-feed/')[1]
        return `${isGlobalView ? '/tenants' : '/customers'}/${selectedCustomer.id}/incident-feed/${tab || 'overview'}`
      }

      case pathname.includes('incidents'):
        return `${isGlobalView ? '/tenants' : '/customers'}/${selectedCustomer.id}/incidents`

      case pathname.includes('add-admin'):
          return `/customers/${selectedCustomer.id}/settings/add-admin`
        
      case pathname.includes('advanced-settings'):
            return `/advanced-settings`
            
      case pathname.includes('settings'):
          return `/customers/${selectedCustomer.id}/settings`

      case pathname.includes('license-management') || pathname.includes('device') || pathname.includes('user'):
          return `${isGlobalView ? '/tenants' : '/customers'}/${selectedCustomer.id}/license-management`  

      case pathname.includes('licensemanagement'):
          return `${isGlobalView ? '/tenants' : '/customers'}/${selectedCustomer.id}/license-management`

      case pathname.includes('deployment'):
          return `${isGlobalView ? '/tenants' : '/customers'}/${selectedCustomer.id}/deployment`
      
      case pathname.includes('soc-integration'):
        return `/soc-integration`
      
      case pathname.includes('threat-intel'):
        return `/threat-intel`

      case pathname.includes('risk-profiles'):
        return this.getCredentialMonitoringPath(selectedCustomer, isGlobalView);

      case pathname.includes('governance'):
        return `/customers/${selectedCustomer.id}/governance`;

      case pathname.includes('policy-violations'):
        return `/customers/${selectedCustomer.id}/policy-violations`;
    }
  }

  handleSelect = (customerDetails) => {
    const { selectedCustomer, setInfo, setCurrentCustomer, history, licenseType } = this.props;

    let { location } = history;
    let path = location.pathname.split('/').pop();
    let isGlobalView = customerDetails.organizationName === globalViewText;
    let isSuperFeedView = customerDetails.organizationName === superFeedViewText;
    const { multiGroup } = customerDetails;

    const isLicenseOrSoc = path === 'license-management' || path === 'soc-integration' || path === 'threat-intel';
    const isOnGovernancePath = location.pathname.includes('/governance');
    // The Incident Feed IS available in Global View (both endpoints support r=M), so this
    // boolean EXEMPTS it rather than blocking it.
    //
    // 🔴 It is not redundant. `path` above is only the LEAF segment, which for a tabbed
    // route is the tab name — and the Incident Feed has a `policy-violations` TAB while
    // `policy-violations` is also a standalone screen in GLOBAL_VIEW_DISABLED_PATHS.
    // Without this guard, switching to Global View from that tab bounces the admin to
    // /incidents for a screen they were never on. menuRegistry.hasDisabledSegment has the
    // matching guard. PIXMC-6521.
    const isOnIncidentFeedPath = location.pathname.includes('/incident-feed');
    const shouldRedirectGlobalVw = (isGlobalView && !isOnIncidentFeedPath && (GLOBAL_VIEW_DISABLED_PATHS.includes(path) || isOnGovernancePath)) || (isLicenseOrSoc && multiGroup);
    const shouldRedirectThreatInt = 
          (customerDetails.licenseType === THREAT_INTEL_CUST_LICENSE_CODE 
          && !THREAT_INTEL_CUST_VALID_PATHS.some(validPath => matchPath(location.pathname, { path: validPath, exact: true, strict: false })))

    if (isSuperFeedView) {
      //redirect to super feed view
      history.push(`/super-feed`);
    }

    if (shouldRedirectGlobalVw) {
      // Adding Timeout to ensure React Stack is loaded properly, so that the state is passed correctly to the incidents component
      setTimeout(() => {
        // show message and redirect to incidents when global is selected when the location is settings
        setInfo(`${GLOBAL_VIEW_DISABLED_MESSAGE} ${path}`)
        this.props.history.push(`/tenants/${customerDetails.id}/incidents`, { reason: 'globalViewNotAllowed' });
        }, 0);  
    }

    if(shouldRedirectThreatInt) {
      // show message and redirect to incidents when global is selected when the location is settings
      setInfo(THREAT_INTEL_DISABLED_MESSAGE)
      history.push(`/threat-intel`)
    }

    //redirect from threat intel feed or Super Feed to incidents page on customer Selection
    if ( !isSuperFeedView && (location.pathname.includes('threat-intel-feed') || location.pathname.includes('super-feed'))) {
      // this is not required as per bug raised : ticket# 3862- https://pixmsecurity.atlassian.net/browse/PIXMC-3862
      // setInfo(`Redirecting to incidents page as Selected Customer has changed`)
      let isGlobalView = customerDetails.organizationName === globalViewText;
      history.push(`${isGlobalView ? '/tenants' : '/customers'}/${customerDetails.id}/incidents`);
    }

    setCurrentCustomer(customerDetails);
    shouldRedirectThreatInt || history.push(this.renderSelectedCustomerData(customerDetails))
  }

  handleLogoClick = () => {
    let { selectedCustomer } = this.props
    let isGlobalView = selectedCustomer.organizationName === globalViewText;
    this.props.history.push(`${isGlobalView ? '/tenants' : '/customers'}/${selectedCustomer.id}/incidents`)
  }

  getCredentialMonitoringPath = (selectedCustomer, isGlobalView) => {
    if(isCredentialMonitoringEnabled(selectedCustomer)) {
      return `${'/customers'}/${selectedCustomer.id}/risk-profiles`
    } else {
      this.props.setInfo("This customer does not have Credential Monitoring enabled.");
      return `${isGlobalView ? '/tenants' : '/customers'}/${selectedCustomer.id}/incidents`
    }
  }

  render() {
    const { userName, isLoggedIn, orgList } = this.props

    let preventClick = true
    if(this.props.selectedCustomer) {
      preventClick = false
    }

    return (
      <div className="pixm-nav">
        <nav className="navbar navbar-expand-lg navbar-light bg-none d-flex navContainer">
          <span className={`navbar-brand ${!isLoggedIn ? 'flex-grow-1' : ''}`}>
            {this.state.isPA ? <img
              style={{cursor:'pointer'}}
              onClick={ () => !preventClick ? this.handleLogoClick() : null}
              src={logoWithText}
              height="40"
              className="d-inline-block align-top"
              alt=""
            /> : !this.props.logoLoading ? 
            <img
              style={{cursor:'pointer'}}
              onClick={ () => !preventClick ? this.handleLogoClick() : null}
              src={this.props.logo}
              height="40"
              className="d-inline-block align-top"
              alt=""
            /> : <div className='loader'></div> }
          </span>
          {isLoggedIn && (
            <div
              style={{ margin: '0 10vw', position: 'relative' }}
              className="d-flex flex-grow-1 align-items-center"
            >
            </div>
          )}
          {isLoggedIn && this.props.tokenRoles === 'CustomerAdmin' && this.state.showDropdown && (
            <div
              style={{ padding: '0 0.6vw', fontSize: '16px' , marginRight: "135px"}}
            >
              <img
                style={{ width: '22px', marginTop: '-2px' }}
                src={OrgSvg}
                alt=""
              />
              {this.props.selectedCustomer.organizationName}
            </div>
          )}
          {!isLoggedIn && this.state.showDropdown && (
            <div className="cursor-pointer d-flex align-items-center">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.pixm.net"
                style={{ color: '#000' }}
              >
                Support
                <img
                  style={{ width: '2.2vw' }}
                  src={supportSvg}
                  alt=""
                  srcSet=""
                />
              </a>
            </div>
          )}
          {isLoggedIn && (
            <React.Fragment>
              { this.state.showDropdown && (this.props.tokenRoles !== 'CustomerAdmin') && (<SelectBox
                role="CustomerAdmin,PixmAdmin,TenantAdmin"
                width="300px"
                optionBoxWidth="250px"
                options={orgList}
                onSelect={this.handleSelect}
                icon={OrgSvg}
                iconClass=""
                type="org"
                showSearch={true}
              />) }
              <div className='userName'>
                {userName}
              </div>

              <ProfilePopover {...this.props} />
            </React.Fragment>
          )}
        </nav>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  userName: state.entities.user.name,
  tokenRoles: state.entities.user.roles,
  isLoggedIn: state.entities.user.isLoggedIn,
  // filters: state.entities.events.filters,
  orgList: state.entities.customers.list,
  selectedCustomer: state.entities.customers.selected,
  logo : state.entities.customers.logo,
  logoLoading : state.entities.customers.logoLoading,
  domain : state.entities.user.domain,
  licenseType: state.entities.customers.selected?.licenseType,
})

const mapDispatchToProps = (dispatch) => ({
  // loadEvents: (filters, selectedId, isGlobalView) => dispatch(loadEvents(filters, selectedId, isGlobalView)),
  setCurrentCustomer: (selectedId, isGlobalView) => dispatch(setCurrentCustomer(selectedId, isGlobalView)),
  // getBrands:(selectedId, isGlobalView) => dispatch(getBrands(selectedId, isGlobalView)),
  // clearEvents: () => dispatch(clearEvents()),
  // getExtensionUsers:(selectedId, isGlobalView) => dispatch(getExtensionUsers(selectedId, isGlobalView)),
  // getExtensionUsersCount: (selectedId, isGlobalView) => dispatch(getExtensionUsersCount(selectedId, isGlobalView)),
  setInfo: (error) => dispatch(setInfo(error)),
  getLogo: (body) => dispatch(getLogo(body)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar))
